/**
 * SharedConfigProvider
 * React context provider for shared package configuration
 */

import React, { createContext, useContext, type ReactNode } from 'react';

export interface SharedConfig {
    apiBaseUrl: string;
    h5pServerUrl: string;
    getAuthToken?: () => string | null;
    timeout?: number;
}

const SharedConfigContext = createContext<SharedConfig | null>(null);

export interface SharedConfigProviderProps {
    config: SharedConfig;
    children: ReactNode;
}

export const SharedConfigProvider: React.FC<SharedConfigProviderProps> = ({ config, children }) => {
    return <SharedConfigContext.Provider value={config}>{children}</SharedConfigContext.Provider>;
};

export function useSharedConfig(): SharedConfig {
    const context = useContext(SharedConfigContext);
    if (!context) {
        throw new Error('useSharedConfig must be used within a SharedConfigProvider');
    }
    return context;
}

export function useSharedConfigOptional(): SharedConfig | null {
    return useContext(SharedConfigContext);
}
